import React from 'react';
import ReactMarkdown from 'react-markdown';
import './ui.css';

// #231a: gemeinsames Markdown-Rendering für KI-Antworten und Kommentare.
// react-markdown 9 ohne rehype-raw: rohes HTML wird als Text gezeigt (kein XSS-Vektor).
//
// variant 'ai'      – KI-Inhalte (Suche, Ähnliche Vorfälle, Zusammenfassungen): volles Markdown.
// variant 'comment' – Benutzerkommentare, konservativ: keine Überschriften/Bilder/Trennlinien
//                     (Bestandskommentare mit „# " am Zeilenanfang bleiben normaler Text) und
//                     einfache Zeilenumbrüche bleiben Umbrüche (Klartext-Kommentare sollen so
//                     aussehen wie bisher, nur mit **fett**/Listen obendrauf).
const AI_DISALLOWED = ['img'];
const COMMENT_DISALLOWED = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'img', 'hr'];

// Einzelne Zeilenumbrüche (nicht Absätze) als harte Umbrüche markieren — außerhalb von Code-Fences.
function preserveSingleLineBreaks(text) {
  const parts = String(text).split(/(```[\s\S]*?```)/g);
  return parts.map((part, idx) => (idx % 2 === 1 ? part : part.replace(/([^\n])\n(?!\n)/g, '$1  \n'))).join('');
}

const components = {
  a: ({ node, children, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer">{children}</a>
};

const MarkdownText = ({ children, variant = 'ai', className = '' }) => {
  const raw = typeof children === 'string' ? children : String(children ?? '');
  if (!raw.trim()) return null;
  const isComment = variant === 'comment';
  const text = isComment ? preserveSingleLineBreaks(raw) : raw;
  return (
    <div className={`ui-markdown ui-markdown-${variant} ${className}`.trim()}>
      <ReactMarkdown
        disallowedElements={isComment ? COMMENT_DISALLOWED : AI_DISALLOWED}
        unwrapDisallowed
        components={components}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownText;
